<script setup lang="ts">
import { computed } from "vue";
import { useFormattedDate } from "./useFormattedDate";

const props = defineProps<{
  value: Date | string;
  distance?: boolean;
  full?: boolean;
  long?: boolean;
  longDate?: boolean;
  short?: boolean;
  shortTime?: boolean;
}>();

const { full, long, short, distance, date, shortTime, longDate } = useFormattedDate(() => props.value);
const text = computed(() => {
  if (props.distance) {
    return distance;
  }
  if (props.shortTime) {
    return shortTime;
  }
  if (props.full) {
    return full;
  }
  if (props.long) {
    return long;
  }
  if (props.longDate) {
    return longDate;
  }
  return short;
});
</script>

<template>
  <slot
    :long="long"
    :short="short"
    :distance="distance"
    :date="date"
    :full="full"
    :short-time="shortTime"
  >
    <time
      :datetime="date.toISOString()"
      :title="full"
      v-bind="$attrs"
    >
      {{ text }}
    </time>
  </slot>
</template>
